"use client";
import useAction from "@/commonJS/Actions/actions";
import React, { createContext, memo, ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import {
  button,
  formChild,
} from "../CommonForm/CommonFormInterface";
import {
  actionInterface,
  onChangeActioninterface,
  Scripts,
} from "@/commonJS/Actions/actionInterface";
import CommonForm from "../CommonForm/CommonForm";
import { usePathname, useSearchParams } from "next/navigation";
import { getBase64FromUrl } from "@/commonJS/getBase64";
import useConditions from "@/commonJS/verifyConditions";
import { setCookie } from "@/commonJS/clientStorageActions";
import { removeFromPath } from "@/utils/removeFromPath";
import { debounceInstace } from "@/commonJS/debounce";
import dynamic from "next/dynamic";
import Script from "next/script";
import { renderScript } from "@/utils/renderScript";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { useAppState } from "@/context/AppStateContext";
const LockedScreenMode = dynamic(() => import("../LockedScreenMode/LockedScreenMode"), {
  ssr: false,
});
export const CommonFormContext = createContext<any>(null);

const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};

const MainComponent = ({
  json,
  initialData,
  dynamicValues,
  scripts,
  loadCashfree,
  locale,
  children,
  isLayout,
  layouts
}: {
  json: formChild[];
  initialData?: any;
  dynamicValues?: any;
  loadCashfree?:boolean
  scripts: Scripts[]
  locale?:string
  children?:ReactNode;
  isLayout?:boolean;
  layouts?:Array<any>
}) => {
  
  const pathname = usePathname();
  const queryParams = useSearchParams();
  const {dispatch, state: {layoutStore}} = useAppState();
  const isClient = useIsClient();
  // const dispatch = useAppDispatch();
  const originalPathValue = `${removeFromPath(pathname)?.cleanedUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
  const [allScripts, setAllScripts] = useState<Scripts[]>([...(scripts??[])]);
  const [globalState, setGlobalState] = useState<any>({
    language:locale,
    path: pathname,
    attach_prescription:true,
    original_path: removeFromPath(pathname)?.cleanedUrl,
    baseUrl: typeof window !== 'undefined' ? window.location.origin : "",
    dynamicSlugValues: {...dynamicValues, last_param: ((pathname ?? '')?.split("/")?.pop() ?? '') },
    query: Object.fromEntries(queryParams.entries()),
    original_path_with_query: originalPathValue,
    cashfree_base_url:process.env.NEXT_PUBLIC_CASHFREE_BASE_URL ?? "https://sandbox.cashfree.com",
    drawers:{
      'login-drawer':false
    },
    today: new Date().toLocaleDateString("en-GB"),
    alphabets:"ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    modals:{
      'show_add_address_modal':false,
      'show_change_address_modal':false,
    },
    genericAssuredProductArrayState:[
      {
        id:"",
        flag:true
      }
    ],
    cartPayload:{
      cart_id: "",
      products:[
        
      ]
    },
    add_to_cart_carousel: [{ "id": null, "qty": null }],
    paymentSessionId:null,
    saving_calculation: {
      total_current_mrp: 0,
      medkart_price: 0,
      savings_current_amount: 0,
      savings_yearly_amount: 0,
      savings_current_percentage: 0
    },
    savings_slider_value: 1,
    PLPScrollMeta: {
      page: 1,
      next_page: 2,
      last_page: null
    },
    ordersScrollMeta: {
      page: 1,
      next_page: 2,
      last_page: null
    },    
    ...(initialData ?? {}),
  });
  const callAction = useAction(globalState, globalState, setGlobalState,locale);

  const verifyConditions = useConditions(globalState);

    useEffect(() => {
    dispatch({
      type: "SET_REDUX_STATE",
      payload: {
        action: {
          actionType: "updateReduxState",
          reducer: "layout",
        },
        payload: {
          ...(initialData?.redux?.layout ?? {}),
          path: pathname,
        },
      },
    });
  }, []);

  useEffect(()=>{
    dispatch({type: "SET_LAYOUT_STATE", payload: {...(initialData?.redux?.layout ?? {}), path: pathname}});
  },[]);

  useEffect(() => {
    setGlobalState((prev: any) => ({ ...prev, isClient }));
  }, [isClient]);

  useEffect(() => {    
    setGlobalState((prev: any) => ({...Object.assign(prev, initialData)}));
  }, [initialData]);

  const getClassNames = useCallback(
    (
      field: any,
      globalStateLocal: any,
      fullGlobalState: any,
      extendClassNameKey = "className",
      extendConditionalClassNames = "conditionalClassNames"
    ) => {
      if (!field || typeof field !== "object") return "";

      const baseClasses = (field?.[extendClassNameKey] ?? "").trim();
      let currentClassSet = new Set(baseClasses.split(/\s+/));

      const conditionalClasses = field?.[extendConditionalClassNames];
      if (conditionalClasses && typeof conditionalClasses === "object") {
        Object.keys(conditionalClasses).forEach((value: string) => {
          const isValid = verifyConditions(
            conditionalClasses[value],
            globalStateLocal,
            globalStateLocal,
            fullGlobalState,
          );
          if (isValid && !currentClassSet.has(value)) {
            currentClassSet.add(value);
          } else if (!isValid && currentClassSet.has(value)){
            currentClassSet.delete(value);
          }
        });
      }

      return Array.from(currentClassSet).join(" ");
    },
    [layoutStore, globalState]
  );
  
  useEffect(()=>{
    if(scripts?.length){
      setAllScripts((prev: Scripts[]) => [...prev, ...scripts ??[]]);
    }
  },[scripts]);

  useEffect(()=>{
    setGlobalState({
      ...globalState,
      query: Object.fromEntries(queryParams.entries()),
    })
  },[queryParams])
  if(locale){
    setCookie("lang",locale)
  }

  useEffect(() => {
    const event = new CustomEvent("routeChanged", {
      detail: { pathname: removeFromPath(pathname)?.cleanedUrl },
    });
    window.dispatchEvent(event);
  }, [pathname]);

 
  useEffect(()=>{
    if(loadCashfree){
      if(globalState.paymentSessionId && globalState.paymentSessionId !== ""){
        //@ts-ignore
        const cashfree = new Cashfree({
          mode: process.env.NEXT_PUBLIC_PAYMENT_MODE ?? "sandbox",
        });
        cashfree.checkout({
          paymentSessionId:globalState.paymentSessionId,
          redirectTarget: "_self"
        });
        setGlobalState({...globalState, paymentSessionId:null})
      }
    }
  },[loadCashfree, globalState.paymentSessionId])

  const loadScript = (src:string) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  useEffect(() => {
    if(loadCashfree){
      loadScript("https://sdk.cashfree.com/js/v3/cashfree.js");
    }
  }, []);
  const handleClick =  (
    e: React.MouseEvent<HTMLButtonElement>,
    field: button,
    payload: any,
  ) => {
    const actions = field?.actions ?? [];    
    for (let i = 0; i < actions?.length; i++) {
      // @ts-ignore
      const { debounce: { id, time = 0 } = {} } = actions[i];
      if(time){
        const debounceCallAction = debounceInstace(callAction, time ?? 0, id);
        debounceCallAction(actions[i], payload);
      } else {
        callAction(actions[i], payload)
      }
    }
  }
  const handleMouseEnter =  (
    e: React.MouseEvent<HTMLButtonElement>,
    field: any,
    payload: any,
  ) => {
    const actions = field?.properties?.onMouseEnter?.actions ?? [];
    for (let i = 0; i < actions?.length; i++) {
      callAction(actions[i], payload)
    }
  }
  const handleMouseLeave =  (
    e: React.MouseEvent<HTMLButtonElement>,
    field: any,
    payload: any,
  ) => {
    const actions = field?.properties?.onMouseLeave?.actions ?? [];
    for (let i = 0; i < actions?.length; i++) {
      callAction(actions[i], payload)
    }
  }

  const handleOnChange = async(e: any, actions: onChangeActioninterface[], inputType = "text", collectionStateOrPayload:any) => {
   let value = e?.target?.value;
   
   if(inputType === "file"){
     let files:any = [];
     for(const d in value.files){
       if(d !== "length" && d !== "item"){
        let img64 = await getBase64FromUrl(value.files[d]);
        
        files.push({ base64: img64 });
      }
     }
    value = {files};
   }
    return actions?.map(async(action: actionInterface) => {
      // @ts-ignore
      const { debounce: { id, time = 0 } = {} } = action;
        const debounceCallAction = debounceInstace(callAction, time ?? 0, id);
        if(time){
          debounceCallAction(action, value);
        } else {
          callAction(action, value);
        }
    });
  };
  const handleOnBlur = (e: any, actions: onChangeActioninterface[]) => {
   
    return actions?.map((action: onChangeActioninterface) => {
      callAction(action, e?.target?.value);
    });
  };
  // TODO : add logic as per require
  const handleOnFocus = (e: any, actions: onChangeActioninterface[]) => {
    return actions?.map((action: onChangeActioninterface) => {
      callAction(action, e?.target?.value);
    });
  }

  useEffect(() => {
    const actions = json?.[0]?.onCSRLoad ?? [];
    for (let i = 0; i < actions?.length; i++) {
      callAction(actions[i]);
    }
  }, []);

  const uniquePath = useMemo(()=>[`parent-cf`],[]);
  const parentPath = useCallback((layoutIndex:number)=>[`parent-layout-${layoutIndex}`],[]);

  return (
    <>
      {!layoutStore?.isLanscape ? (
        <CommonFormContext.Provider
          value={{
            handleClick,
            handleMouseEnter,
            handleMouseLeave,
            handleOnChange,
            handleOnBlur,
            handleOnFocus,
            verifyConditions,
            locale,
            getClassNames,
            callAction,
            isClient,
          }}
        >
          {isLayout ? (
            layouts &&
            layouts?.length > 0 &&
            layouts?.map((layout: any, layoutIndex: number) => {
              return layout?.type === "layout" ? (
                <CommonForm
                  key={parentPath(layoutIndex).join("")}
                  path={parentPath(layoutIndex)}
                  formJSON={layout?.data ?? []}
                  setGlobalState={setGlobalState}
                  globalState={globalState}
                  fullGlobalState={globalState}
                  router={pathname}
                />
              ) : (
                children
              );
            })
          ) : (
            <CommonForm
              key={uniquePath.join("")}
              path={uniquePath}
              formJSON={json}
              setGlobalState={setGlobalState}
              globalState={globalState}
              fullGlobalState={globalState}
              router={pathname}
            />
          )}
        </CommonFormContext.Provider>
      ) : (
        <LockedScreenMode />
      )}
      {allScripts.map((parameters: Scripts, index: number) => {
        if (parameters.delay && parameters.delay > 0) {
          renderScript(parameters, "script-" + index);
          return null;
        }
        return <Script key={"script-" + index} {...parameters} />;
      })}
    </>
  );
};

export default MainComponent;
